import {NgModule} from "@angular/core";
import {RouterModule, Routes} from "@angular/router";
import {
    AboutFaqComponent,
    AboutLegalNoticeComponent,
    AboutPartnersComponent,
    AboutTeamComponent,
    AnalyticsRouteDataService
} from "@kwsoft/otcx-core";


export const routes: Routes = [
    {
        path: "",
        children: [
            {path: "", pathMatch: "full", redirectTo: "legalNotice"},
            {
                path: "faq",
                component: AboutFaqComponent,
                data: AnalyticsRouteDataService.createRouteData({
                    pageId: "04bbbd4a-7e3c-49ae-be2a-b34a5617349a"
                })
            },
            {
                path: "legalNotice",
                component: AboutLegalNoticeComponent,
                data: AnalyticsRouteDataService.createRouteData({
                    pageId: "99cbf632-e33f-4868-923c-cce529babf93"
                })
            },
            {
                path: "partners",
                component: AboutPartnersComponent,
                data: AnalyticsRouteDataService.createRouteData({
                    pageId: "a3ca3fcf-8e8c-4ffa-acd9-c5b9eefbae09"
                })
            },
            {
                path: "team",
                component: AboutTeamComponent,
                data: AnalyticsRouteDataService.createRouteData({
                    pageId: "da148eaa-5615-494e-8b9d-792bb2d89d49"
                })
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AboutRoutingModule {
}
